<section class="carousel row" #carousel touchGestures (onWindowResize)="onCarouselResize()" (swipeLeft)="onSwipeLeft()" (swipeRight)="onSwipeRight()">
	<ng-container *ngFor="let item of data; let index = index">
		<ng-container *ngTemplateOutlet="template; context: { data: item, isStackedCard: index < stackedCardsCount }"></ng-container>
	</ng-container>
</section>

<section class="carousel-buttons">
	<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
	<button type="button" class="left-btn carousel-btn" custom-tracking track-event="carousel:cta:left" [disabled]="shouldDisableLeft()" (click)="onLeft()">
		<icon type="arrow-circle-left"></icon>
	</button>
	<button type="button" class="right-btn carousel-btn" custom-tracking track-event="carousel:cta:right" [disabled]="shouldDisableRight()" (click)="onRight()">
		<icon type="arrow-circle-right"></icon>
	</button>
</section>
